export const valueOrNA = (
  value: string | number | null | undefined,
): string | number => {
  return value ?? "N / A";
};
